export default "__VITE_ASSET__BXII3lMq__"